import React, { Component } from "react";
import { toFrenchDays } from "../../../../../ReactConst";
import DateFnsUtils from "@date-io/moment";
import moment from "moment";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import Img from "react-image";
import _ from "lodash";
import Close from "../../../../../Icons/Close";
import iconValider from "../../../../../styles/img/icon-check-white.svg";
import { styles } from "../../../../../ReactConst";
import { StyleRoot } from "radium";
const materialTheme = createMuiTheme({
  palette: {
    primary: { main: "#1d4cc5" },
  },
  overrides: {
    MuiInputBase: {
      root: {
        position: "relative",
        boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none",
        padding: "0 15px",
        fontWeight: "600",
        fontSize: "18px",
        color: "#000",
      },
      input: {
        textAlign: "center",
        borderRadius: "50px",
        border: "none",
        background: "#fff",
        outline: "none !important",
        fontWeight: "normal",
        fontSize: "18px",
        color: "#000",
      },
    },
    MuiInput: {
      underline: {
        "&::before": {
          content: "none",
        },
        "&::after": {
          content: "none",
        },
      },
    },
  },
});
let data = {
  horaires: {
    WEDNESDAY: {
      ouvert: true,
      horaireDebut: "07:00:00",
      horaireFin: "17:30:00",
      numDay: "1",
    },
    MONDAY: { ouvert: true, horaireDebut: "07:00:00", horaireFin: "17:30:00" },
    FRIDAY: { ouvert: true, horaireDebut: "07:00:00", horaireFin: "17:30:00" },
    SUNDAY: { ouvert: false },
    SATURDAY: { ouvert: false },
    THURSDAY: {
      ouvert: true,
      horaireDebut: "07:00:00",
      horaireFin: "17:30:00",
    },
    TUESDAY: { ouvert: true, horaireDebut: "07:00:00", horaireFin: "17:30:00" },
  },
  infosUtiles: "Fermé le nouvel an",
};
const IconValider = () => (
  <Img src={iconValider} className="btn-valid img-fluid" alt="iconPhoto" />
);

export default class ModalHoraires extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Days: [],
      initialized: false,
      styleFadeIn: true,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  switchDays(nameOfDay) {
    switch (nameOfDay) {
      case "MONDAY":
        return 1;

      case "TUESDAY":
        return 2;

      case "WEDNESDAY":
        return 3;

      case "THURSDAY":
        return 4;

      case "FRIDAY":
        return 5;

      case "SATURDAY":
        return 6;

      case "SUNDAY":
        return 7;

      default:
        return 10;
    }
  }
  componentDidMount() {
    if (!this.state.initialized) {
      if (!_.isEmpty(this.props.horaires)) {
        let days = Object.keys(this.props.horaires).map((day) => {
          let numDay = this.switchDays(day);
          this.props.horaires[day]["numDay"] = numDay;
          this.props.horaires[day]["nameOfDay"] = day;
          return this.props.horaires[day];
        });
        let daysOrdred = days.sort((a, b) => a.numDay - b.numDay);
        this.setState({
          Days: daysOrdred,
          initialized: true,
        });
      }
    }
  }
  componentWillUnmount() {}
  handleChange(name, day) {
    this.props.handleChange(name, day);
  }
  handleChangeTimeStart = (date) => {
    this.props.handleChangeTimeStart(date);
  };
  handleChangeTimeEnd = (date) => {
    this.props.handleChangeTimeEnd(date);
  };
  renderInput = (props) => (
    <input
      readOnly
      className="form-control custom-input box-shadowed"
      type="text"
      onClick={props.onClick}
      id={props.id}
      value={props.value}
      {...props.inputProps}
    />
  );
  handleClose = () => {
    this.setState({
      styleFadeIn: false,
      Days: [],
      initialized: false,
    });
    this.props.onClose();
  };
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }
  handleSubmit(e) {
    e.preventDefault();
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onSubmitModal();
    }, 400);
  }

  render() {
    let { horaires, title } = this.props;
    return (
      <StyleRoot>
        <div
          className="modal show modal-skin"
          id="modalHoraires"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <form>
                <button
                  onClick={this.handleClose}
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <Close className="img-fluid" alt="" />
                </button>
                <div className="modal-body">
                  <section>
                    <h5 className="modal-title">{title}</h5>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <div className="form-group">
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <TimePicker
                                autoOk
                                ampm={false}
                                value={this.props.horaireDebut}
                                className="form-control custom-input box-shadowed"
                                onChange={this.handleChangeTimeStart}
                                format={"HH[h]mm"}
                                minutesStep={5}
                                TextFieldComponent={this.renderInput}
                                name="horaireDebut"
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group">
                          <ThemeProvider theme={materialTheme}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <TimePicker
                                autoOk
                                ampm={false}
                                value={moment(this.props.horaireFin)}
                                onChange={this.handleChangeTimeEnd}
                                format={"HH[h]mm"}
                                name="horaireFin"
                                minutesStep={5}
                                className="form-control custom-input box-shadowed"
                                TextFieldComponent={this.renderInput}
                              />
                            </MuiPickersUtilsProvider>
                          </ThemeProvider>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section>
                    <h5 className="modal-title">Quels jours ?</h5>
                    <ul className="row mx-n2 list-enfants list-sans-avatar">
                      {this.state.Days.filter(
                        (element) => element.nameOfDay !== "SUNDAY"
                      ).map((jour, index) => {
                        return (
                          <li key={index} className="col-md-6 px-2">
                            <input
                              type="checkbox"
                              id={index}
                              checked={jour["ouvert"]}
                              readOnly
                            />
                            <label
                              onClick={() =>
                                this.handleChange(jour.nameOfDay, jour)
                              }
                              className="rounded15 box-shadow"
                              htmlFor={jour}
                            >
                              <span className="avatar"></span>
                              <span className="name">
                                {toFrenchDays(jour.nameOfDay)}
                              </span>
                            </label>
                          </li>
                        );
                      })}
                    </ul>
                  </section>
                  <div className="d-flex justify-content-center">
                    <button
                      type="submit"
                      className="btn-gradient btn-valid"
                      style={{ align: "left" }}
                      onClick={(e) => this.handleSubmit(e)}
                    >
                      <IconValider />
                      Valider
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
